// Mock data for M.A. Zulassungsdienst Landing Page

export const businessInfo = {
  name: "M.A. Zulassungsdienst",
  phone: "015159182828",
  phoneDisplay: "01515 9182828",
  address: {
    street: "Kamper Str. 8",
    zip: "42555",
    city: "Velbert",
    country: "Deutschland"
  },
  rating: 4.8,
  reviewCount: 150,
  reviewCountDisplay: "150+",
  whatsappNumber: "4915159182828" // Format for WhatsApp link
};

export const services = [
  {
    id: 1,
    title: "Schnellzulassung vor Ort",
    price: "Nur 149,90€",
    description: "NEU! Ihr Fahrzeug ist in nur 20 Minuten zugelassen und fahrbereit. Direkt aus unserer Agentur - schnell, einfach und ohne Wartezeiten.",
    icon: "Zap",
    featured: true
  },
  {
    id: 2,
    title: "Anmeldung",
    price: "Nur 149,90€ - Alles inklusive!",
    description: "Komplettpaket: Straßenverkehrsamt-Gebühren, Zulassungsservice, Wunschkennzeichen, Kennzeichenerstellung und Feinstaubplakette - alles inklusive.",
    icon: "FileCheck"
  },
  {
    id: 3,
    title: "Ummeldung",
    price: "74,90€",
    description: "Fahrzeugummeldung mit Beibehaltung Ihres Kennzeichens. Nur der Papierkram wird geändert - schnell und unkompliziert.",
    icon: "RefreshCw"
  },
  {
    id: 4,
    title: "Abmeldung",
    price: "39,90€",
    description: "Professionelle Fahrzeugabmeldung ohne Wartezeiten. Alle Unterlagen werden ordnungsgemäß bearbeitet.",
    icon: "FileX"
  },
  {
    id: 5,
    title: "Online-Abmeldung vor Ort",
    price: "19,90€",
    description: "Schnelle Online-Abmeldung direkt bei uns vor Ort. Die günstigste und schnellste Variante für Ihre Fahrzeugabmeldung.",
    icon: "Wifi"
  },
  {
    id: 6,
    title: "Wunschkennzeichen-Service",
    price: "Auf Anfrage",
    description: "Reservierung und Registrierung Ihres Wunschkennzeichens. Ihr persönliches Kennzeichen garantiert.",
    icon: "Star"
  },
  {
    id: 7,
    title: "Kennzeichenerstellung",
    price: "Zusatzservice",
    description: "Benötigen Sie neue Kennzeichen? Wir erstellen diese gerne für Sie gegen einen Aufpreis.",
    icon: "Tag"
  },
  {
    id: 8,
    title: "Dokumentenprüfung",
    price: "Kostenlos",
    description: "Überprüfung aller notwendigen Dokumente vor der Zulassung. Vermeiden Sie unnötige Behördengänge.",
    icon: "Search"
  },
  {
    id: 9,
    title: "KFZ-Versicherungsberatung",
    price: "Kostenlos",
    description: "Persönliche Beratung zu KFZ-Versicherungen. Sparen Sie bares Geld durch optimale Tarifauswahl.",
    icon: "Shield"
  }
];

export const reviews = [
  {
    id: 1,
    name: "Michael K.",
    rating: 5,
    text: "Schnell, professionell und unkompliziert. Innerhalb von 2 Tagen war alles erledigt. Absolut empfehlenswert!",
    date: "vor 2 Wochen"
  },
  {
    id: 2,
    name: "Sarah M.",
    rating: 5,
    text: "Freundlicher Service zum fairen Preis. Keine Wartezeiten beim Amt mehr. Danke für die tolle Unterstützung!",
    date: "vor 1 Monat"
  },
  {
    id: 3,
    name: "Thomas R.",
    rating: 5,
    text: "Nach 3 Tagen alles erledigt. Sehr zufrieden mit dem Service. Persönlicher Ansprechpartner war immer erreichbar.",
    date: "vor 3 Wochen"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Schnelle Bearbeitung",
    description: "Oft innerhalb 1–3 Tage",
    icon: "Zap"
  },
  {
    id: 2,
    title: "Persönlicher Ansprechpartner",
    description: "Immer für Sie erreichbar",
    icon: "User"
  },
  {
    id: 3,
    title: "Keine Wartezeiten",
    description: "Kein Stress beim Amt",
    icon: "Clock"
  },
  {
    id: 4,
    title: "Komplettservice",
    description: "Zulassung + Versicherung",
    icon: "CheckCircle"
  }
];

export const howItWorksSteps = [
  {
    id: 1,
    title: "Anfrage senden",
    description: "Kontaktieren Sie uns per WhatsApp, Telefon oder Formular",
    icon: "MessageSquare"
  },
  {
    id: 2,
    title: "Unterlagen abgeben",
    description: "Bringen Sie die Dokumente vorbei oder senden Sie sie digital",
    icon: "Upload"
  },
  {
    id: 3,
    title: "Wir erledigen alles",
    description: "Wir kümmern uns um alle Behördengänge und Formalitäten",
    icon: "Settings"
  },
  {
    id: 4,
    title: "Fahrzeug abholen",
    description: "Ihr Fahrzeug ist fertig zugelassen und fahrbereit",
    icon: "Car"
  }
];

export const openingHours = [
  { day: "Montag bis Donnerstag", hours: "10:00 – 17:30 Uhr" },
  { day: "Freitag", hours: "10:00 – 15:00 Uhr" },
  { day: "Samstag", hours: "Geschlossen" },
  { day: "Sonntag", hours: "Geschlossen" }
];

export const serviceOptions = [
  "Schnellzulassung vor Ort (20 Min.)",
  "Anmeldung",
  "Ummeldung",
  "Abmeldung",
  "Online-Abmeldung vor Ort",
  "Wunschkennzeichen",
  "Versicherungsberatung",
  "Sonstiges"
];

// Form submission handler - connects to backend API
export const submitLeadForm = async (formData) => {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  
  try {
    const response = await fetch(`${BACKEND_URL}/api/leads`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: formData.name,
        phone: formData.phone,
        service: formData.service,
        message: formData.message || null,
        email: formData.email || null
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || 'Failed to submit form');
    }

    const data = await response.json();
    return {
      success: data.success,
      message: data.message,
      leadId: data.lead_id
    };
  } catch (error) {
    console.error('Form submission error:', error);
    throw error;
  }
};
